import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Silence non-error console outputs (keep console.error)
/* eslint-disable no-console */
console.log = () => {};
console.info = () => {};
console.debug = () => {};
console.warn = () => {};
/* eslint-enable no-console */

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
